import { Dataset, FilterItemType, FilterType, MatchMode } from '../types/types';
import { getDefaultMatchModeByType } from './managerUtils';
import { getSupportedDefaultMatchMode } from './filters/getSupportedDefaultMatchMode';

export const getDefaultLazyStateFilters = (dataset: Dataset, filter?: any) => {
  const newFilters = {};
  if (!dataset.items) {
    return newFilters;
  }
  dataset.items
    .filter((column) => column.visible !== false)
    .forEach((column) => {
      let matchMode: MatchMode;
      let filterItem: FilterItemType | undefined;
      if (filter && filter.items && column.filterParam) {
        filterItem = filter.items.find(
          ({ name }) => name === column.filterParam
        );
      }
      if (filterItem) {
        matchMode = getSupportedDefaultMatchMode(filterItem, column.type);
      } else {
        matchMode = getDefaultMatchModeByType(
          column.type as FilterType | undefined
        );
      }
      newFilters[column.name] = {
        operator: 'and',
        constraints: [
          {
            value: null,
            matchMode,
          },
        ],
      };
    });
  return newFilters;
};
